<template>
	<div class="container">
		<div class="fill_top">
			<div class="fill_top_head">
				<div class="fill_top_head_photo">
					<img :src="imageurl" />
				</div>
				<div class="fill_top_head_text">
					<p>{{title}}</p>
					<p>时间 <span>{{appointmenttime}}</span></p>
					<p>{{site_name}}票</p>
				</div>
			</div>
			<div class="fill_top_bottom">
				<div class="fill_sheets">{{summary}}</div>
				<div class="appointmentsheets">免费预约</div>
			</div>
		</div>
		<div class="personnel_information">
			<div class="information_top">
				<p>参观人员信息</p>
				<div v-if="quxiao" class="information_edit" @click="xiao">取消</div>
				<div class="information_edit" @click="information_edit">{{edit}}</div>
			</div>
			<ul class="information">
				<li v-for="(item,index) in ticketcodelist" :key="index">
					<div v-if="item.show" @click="Delete(item,index)" class="information_delete" v-show="information_delete"><img src="../assets/cancel_red.png" /></div>
					<div v-else="" @click="Delete(item,index)" class="information_delete" v-show="information_delete"><img src="../assets/cancel_white.png" /></div>
					<div class="information_left" v-if="item.realname!=''" @click="information_right(index)">
						<div>
							<div class="information_left_ll">{{ticketcodelist[index].realname}}</div>
							<div class="information_tips" v-if="ticketcodelist[index].userstatus==0">

							</div>
							<div class="information_tips" v-if="ticketcodelist[index].userstatus==1">
								<div>!</div>
								<div>实名信息有误，请确认个人信息</div>
							</div>
						</div>
						<div><span>{{ticketcodelist[index].idcard}}</span><span>{{ticketcodelist[index].telnum}}</span></div>
						<div v-if="ticketcodelist[index].childidcard!=''">
							<p>携带儿童：</p>
							<span class="child" v-for="item in ticketcodelist[index].childidcard">{{item.name}} {{item.idcard}}</span>
						</div>
					</div>
					<div class="information_left" v-if="item.realname==''" @click="information_right(index)">
						请填写参观人实名信息
					</div>
					<div @click="information_right(index)" class="information_right"><img src="../assets/toRight.png" /></div>
				</li>
			</ul>
			<p v-if="ordertype==1" style="margin-top: 20px;width: 100%;float: left;">上传电子行程单：</p>
			<div class="inp_file" v-if="ordertype==1">
				<div v-for="(item,index) in license" class="file">
					<div class="file_img">
						<img :src="item.fileurl" v-if="item.format=='png'||item.format=='gif'||item.format=='jpg'||item.format=='jpeg'" />
						<div v-if="item.format!='png'&&item.format!='gif'&&item.format!='jpg'&&item.format!='jpeg'">{{item.filename}}</div>
					</div>
					<div class="file_no" @click="DeleteFile(item,index)">
						<img src="../assets/file_no.png" />
					</div>
				</div>
				<div class="file">
					<div class="file_img">
						<img src="../assets/shangchuan.png" />
					</div>
					<form id="uploadForm" enctype="multipart/form-data">
						<input id="upload2" accept="image/*" type="file" name="upload" multiple="multiple" v-on:change="uploadFile()" />
						<!--<button name="upload1" id="upload1" type="button" onclick="uploadFile()">upload</button>-->
					</form>
				</div>
			</div>
			<div class="information_btn" @click="information_push">
				添加报名人
			</div>
		</div>
		<div class="appointment_explain">
			<p>预约说明</p>
			<div :class="[height_change?'explain_height_change':'explain_height']">1、网络预约包括网站预约(www.xiangshan1949.cn)和微信公众号预约(微信名：香山革命纪念馆服务号)，每天分以下两个预约入馆时段：上午9:00-12:30，下午12:30-16:30。<br> 2、纪念馆参观预约均采取实名制，可提前30天预约。一个身份证每天只能预约一次，预约当天有效，过时作废。如无法按时入馆参观，观众须在参观前一天16:00前申请取消预约，逾期未取消系统将默认该账号爽约1次。累计爽约3次的账号将计入黑名单，在90天内不能预约。<br> 3、个人观众凭本人有效身份证预约参观，一人一证，参观当日须携带本人有效身份证件。1.3米以下儿童可由家长代为预约，一位家长最多可预约两张儿童票。中小学生、60周岁以上老人、残疾人、现役军人、港澳台及外籍人士无需预约，须携带本人有效相关证件（中小学生学生证、老年证、残疾证、军官证、士兵证、港澳通行证、台胞证、护照），现场核验领票参观。
			</div>
			<div @click="height_auto">
				<img v-if="height_change" src="../assets/toTop.png" />
				<img v-else src="../assets/toBottom.png" />
			</div>
		</div>
		<div class="visit_explain">
			<p>参观说明</p>
			<div :class="[visitHeight?'visit_height_change':'visit_height']">
				1.香山革命纪念馆所有展览免费向公众开放。<br>
				2.开放时间为每天9:00-16:30(16:00停止检票)，周一例行闭馆，国家法定节假日照常开放（春节期间开放事宜另行通知）。<br>
				3.观众需通过官网和微信公众号实名预约。参观当日须配合身份证核录，未见异常后方可入馆。<br>
				4.入馆时请自觉接受体温检查以及安全检查，请勿将各类禁限带物品及宠物带入场馆。<br>
				5.酗酒者、衣冠不整者以及无行为能力或限制行为能力者无监护人陪伴的，谢绝入馆。<br>
				6.疫情防控期间，观众须全程佩戴口罩，排队和观展时请保持1.5米以上距离，避免聚集。<br>
				7.幼童、高龄老人、行动不便者须由成年人陪护入馆。<br>
				8.参观时请自觉遵守参观秩序，请勿大声喧哗、追跑打闹、攀爬躺卧，并请将手机设置为静音以免影响他人参观。<br>
				9.疫情防控期间请勿携带大件物品，行李寄存处暂停使用。<br>
				10.展厅内请勿摄像，允许拍照的展览，请勿使用闪光灯、自拍杆和三脚架。<br>
				11.请观众不要使用馆内电源。<br>
				12.严禁翻越围挡护栏、触摸展品，请自觉爱护展览、服务设施，如造成损坏，须照价赔偿并承担相应的法律责任。<br>
				13.展厅内请勿饮食。<br>
				14.疫情防控期间，建议观众参观时间控制在1.5小时内，以免造成封闭场所人员聚集。<br>
				15.自觉维护环境卫生。请按照《北京市生活垃圾管理条例》要求，将杂物投放到垃圾箱。<br>
				16.按照《北京市控制吸烟条例》要求，请勿在馆内吸烟。<br>
				17.如需使用轮椅请联系馆内工作人员。<br>
				18.如遇我馆重大或临时性活动，请遵从馆内通知安排。<br>
				19.如遇各类突发事件，请服从工作人员指挥。<br>
				20.疫情防控期间，当遇到馆内人员密度较大时，我馆将根据具体情况采取控制入馆速度等措施，敬请谅解。<br>
				感谢您的理解与支持！<br>
			</div>
			<div @click="visit_auto">
				<img v-if="visitHeight" src="../assets/toTop.png" />
				<img v-else src="../assets/toBottom.png" />
			</div>
		</div>
		<div class="fill_btn_bottom">
			<div class="fill_btn" @click="appointment">
				预约
			</div>
		</div>
		<div class="appointment_success" v-show="success">
			<div class="success_center">
				<img v-if="success_img" src="../assets/success.png" />
				<img v-if="!success_img" src="../assets/buttom_x.png" />
				<p>{{success_text}}</p>
				<p v-if="failShow">预约失败!</p>
				<div @click="determine">确定</div>
			</div>
		</div>
		<div class="established" v-show="establishedShow">
			<div class="established_content">
				<div v-if="ordertype=='0'" class="established_top_one">是否继续预约</div>
				<div class="established_top_top" v-if="ordertype=='1'">如实际到馆人数比预约人数少10人以上(含10人)，则团队不允许入馆，三次计入黑名单。疫情期间，参观当天请提供团队所有成员的纸质版姓名及身份证号，以作备案。<br>是否继续预约</div>
				<div class="established_bottom">
					<div @click="establishedYes">确认</div>
					<div @click="establishedNo">取消</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'FillInformation',
		data() {
			return {
				height_change: false,
				license: [],
				visitHeight: false,
				ticketActivity: [],
				ticketcodelist: [],
				name: "",
				IdNumber: "",
				phone: "",
				orderid: "",
				success: false,
				success_text: "",
				success_img: false,
				site_name: "",
				baseUrl: "",
				photo: false,
				imageurl: "",
				title: "",
				appointmenttime: "",
				summary: "",
				ordertype: "",
				taid: "",
				paragraphid: "",
				information_delete: false,
				edit: "编辑",
				Delete_show: false,
				activeClass: -1,
				index_del: [],
				quxiao: false,
				access_token: "",
				baseUrlOne: "",
				failShow: false,
				establishedShow: false
			}
		},
		methods: {
			establishedYes() {
				var that = this;
				that.establishedShow = false;
				wclient.view.showLoading();
				if(that.ordertype == '0') {
					if(sessionStorage.getItem('appointment_type') == 'ticket') {
						$.ajax({
							type: "post",
							url: that.baseUrl + '/tickets/tickets/ajax?ugi=bookingticketorder&action=createTicketOrder&moduleid=TICKETS',
							async: true,
							data: {
								taid: that.taid,
								appointmenttime: that.appointmenttime,
								ordertype: that.ordertype,
								paragraphid: that.paragraphid,
								ticketcodeData: JSON.stringify(that.ticketcodelist),
								access_token: that.access_token
							},
							dataType: 'jsonp',
							crossDomain: true,
							xhrFields: {
								withCredentials: true
							},
							success: function(data) {
								if(data.code == "A00006") {
									wclient.view.hideLoading();
									that.success = true;
									that.success_text = '预约成功';
									that.success_img = true;
									sessionStorage.setItem("orderid", data.ticketorder.orderid);
								} else if(data.code == "A00001") {
									wclient.view.hideLoading();
									that.success = true;
									that.success_text = '系统繁忙，请稍后再试';
									that.success_img = true;
									sessionStorage.setItem("orderid", data.ticketorder.orderid);
								} else  if(data.code == "A00004"){
									if(data.errmsg=='invalid access_token'){
										wclient.baseURL = '//www.xiangshan1949.cn';
										wclient.connect('', function(data) {
											if(data.code == 'A00006') {
												that.success = true;
												wclient.crossdomain = true;
												localStorage.setItem('access_token', data.access_token)
												that.access_token =data.access_token
												that.success_text = '登录成功，请重新预约';
											}
										})
									}else{
										wclient.view.hideLoading();
										that.success = true;
										that.success_text = data.errmsg;
										that.success_img = false;
									}
									// wclient.view.hideLoading();
									
									// that.success_text = data.errmsg;
									// that.success_img = false;
									
								}else{
									wclient.view.hideLoading();
									that.success = true;
									that.success_text = data.errmsg;
									that.success_img = false;
								}
							}
						});
					} else if(sessionStorage.getItem('appointment_type') == 'activity') {
						$.ajax({
							type: "post",
							url: that.baseUrl + '/tickets/tickets/ajax?ugi=bookingticketorder&action=createTicketOrder&moduleid=TICKETS',
							async: true,
							data: {
								taid: that.taid,
								appointmenttime: that.appointmenttime,
								ordertype: that.ordertype,
								paragraphid: that.paragraphid,
								ticketcodeData: JSON.stringify(that.ticketcodelist)
							},
							dataType: 'jsonp',
							crossDomain: true,
							xhrFields: {
								withCredentials: true
							},
							success: function(data) {
								if(data.code == "A00006") {
									wclient.view.hideLoading();
									that.success = true;
									that.success_text = '预约成功';
									that.success_img = true;
									sessionStorage.setItem("orderid", data.ticketorder.orderid);
								} else if(data.code == "A00001") {
									wclient.view.hideLoading();
									that.success = true;
									that.success_text = '系统繁忙，请稍后再试';
									that.success_img = true;
									sessionStorage.setItem("orderid", data.ticketorder.orderid);
								} else {
									wclient.view.hideLoading();
									that.success = true;
									that.success_text = data.errmsg;
									that.success_img = false;
								}
							}
						});
					}
				} else {
					$.ajax({
						type: "post",
						url: that.baseUrl + "/tickets/tickets/ajax?ugi=bookingticketorder&action=createTicketOrder&moduleid=TICKETS",
						async: true,
						crossDomain: true,
						data: {
							taid: that.taid,
							appointmenttime: that.appointmenttime,
							ordertype: that.ordertype,
							paragraphid: that.paragraphid,
							ticketcodeData: JSON.stringify(that.ticketcodelist),
							access_token: that.access_token,
							license: JSON.stringify(that.license)
						},
						dataType: 'jsonp',
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
						success: function(data) {
							if(data.code == "A00006") {
								wclient.view.hideLoading();
								that.success = true;
								that.success_text = '预约成功';
								that.success_img = true;
								sessionStorage.setItem("orderid", data.ticketorder.orderid);

							} else if(data.code == "A00001") {
								wclient.view.hideLoading();
								that.success = true;
								that.success_text = '系统繁忙，请稍后再试';
								that.success_img = true;
								sessionStorage.setItem("orderid", data.ticketorder.orderid);
							} else if(data.code == "A00008") {
								wclient.view.hideLoading();
								that.success = true;
								that.success_text = '您上传的电子行程单内容有误';
								that.success_img = false;
								that.failShow = true;
							} else {
								wclient.view.hideLoading();
								that.success = true;
								that.success_text = data.errmsg;
								that.success_img = false;
							}

						}
					}); 
				}
			},
			establishedNo() {
				var that = this;
				that.establishedShow = false;
			},
			DeleteFile(item, index) {
				var that = this;
				that.license.splice(index, 1)
				sessionStorage.setItem('license', JSON.stringify(that.license))
			},
			uploadFile() {
				var that = this;
				wclient.view.showLoading();
				$.ajax({
					url: that.baseUrlOne + '/account/upload/file/uploads',
					type: 'POST',
					cache: false,
					data: new FormData($('#uploadForm')[0]),
					processData: false,
					contentType: false
				}).done(function(res) {
					var data = $.parseJSON(res);
					wclient.view.hideLoading();
					if(data.code == 'A00006') {
						if(data.fileurl.length == 1) {
							if(that.license.length > 2) {
								that.success = true;
								that.success_text = '最多上传三个文件';
								that.success_img = false;
							} else {
								that.license.push({
									"fileid": data.fileurl[0].fileid,
									"fileurl": data.fileurl[0].fileurl,
									"filename": data.fileurl[0].filename,
									"format": data.fileurl[0].format
								});
								sessionStorage.setItem('license', JSON.stringify(that.license))
							}
						} else {
							if(data.fileurl.length > 3) {
								that.success = true;
								that.success_text = '最多上传三个文件';
								that.success_img = false;
							} else {
								that.license = data.fileurl;
								sessionStorage.setItem('license', JSON.stringify(that.license))
							}
						}
					} else {
						that.success = true;
						that.success_text = data.errmsg;
						that.success_img = false;
					}

				}).fail(function(res) {});

			},
			xiao() {
				var that = this;
				that.edit = "编辑";
				that.quxiao = false;
				that.information_delete = false;
				for(var i = 0; i < that.ticketcodelist.length; i++) {
					that.ticketcodelist[i].show = false
				}
			},
			height_auto() {
				var that = this;
				that.height_change = !that.height_change;
			},
			visit_auto() {
				var that = this;
				that.visitHeight = !that.visitHeight;
			},
			information_right(e) {
				sessionStorage.setItem("e", e);
				var that = this;
				that.$router.push({
					name: 'Information'
				});
			},
			information_edit() {
				var that = this;
				that.quxiao = true;
				if(that.edit == "编辑") {
					that.information_delete = true;
					that.edit = "删除";
				} else {
					if(that.index_del.length == 0) {
						that.success = true;
						that.success_text = '未选择删除信息';
						that.success_img = false;
					} else {
						that.quxiao = false;
						var arr = [];
						var obj = {};
						for(var j = 0; j < that.index_del.length; j++) {
							obj[that.index_del[j]] = 1;
						}
						for(var i = 0; i < that.ticketcodelist.length; i++) {
							if(!obj[i]) {
								arr.push(that.ticketcodelist[i])
							}
						}
						that.ticketcodelist = arr;
						that.index_del = [];
						that.information_delete = false;
						that.edit = "编辑";
						sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
					}
				}
			},
			Delete(item, index) {
				var that = this;
				if(item.show == false) {
					that.index_del.push(index)
				} else {
					for(var i = 0; i < that.index_del.length; i++) {
						if(that.index_del[i] == index) {
							that.index_del.splice(i, 1)
						}
					}
				}
				that.ticketcodelist.forEach(i => {
					if(item.show !== that.ticketcodelist[index].show) {
						i.show = false;
					}
				});
				item.show = !item.show;
			},
			appointment() {
				var mo = function(e) {
					e.preventDefault();
				};
				document.body.style.overflow = 'hidden';
				document.addEventListener("touchmove", mo, false)
				var that = this;
				for(var i = 0; i < that.ticketcodelist.length; i++) {
					if(that.ticketcodelist[i].certificate_type == '中国大陆身份证') {
						that.ticketcodelist[i].certificate_type = 'idcard';
					} else if(that.ticketcodelist[i].certificate_type == '港澳居民来往内地通行证') {
						that.ticketcodelist[i].certificate_type = 'HK_MO_TWN_idcard';
					} else if(that.ticketcodelist[i].certificate_type == '台湾居民来往大陆通行证') {
						that.ticketcodelist[i].certificate_type = 'HK_MO_TWN_idcard';
					} else if(that.ticketcodelist[i].certificate_type == '护照') {
						that.ticketcodelist[i].certificate_type = 'passport';
					}
				}
				var token = localStorage.getItem("access_token");
				for(var i = 0; i < that.ticketcodelist.length; i++) {
					if(that.ticketcodelist[i].realname == '') {
						that.success = true;
						that.success_text = '未填写完全信息';
						that.success_img = false;
						return;
					}
				}
				if(that.ticketcodelist == "") {
					that.success = true;
					that.success_text = '请添加报名人';
					that.success_img = false;
				} else if(that.ordertype == '1' && that.ticketcodelist.length < 11) {
					that.success = true;
					that.success_text = '您的预约人数没有超过11人，不符合团队预约条件，请通过个人预约方式预约参观';
					that.success_img = false;
				} else {
					if(that.ordertype == '0') {
						var num = 0;
						for(var i = 0; i < that.ticketcodelist.length; i++) {
							if(that.ticketcodelist[i].idcard != '' && that.ticketcodelist[i].idcard != undefined) {
								num = num + 1 + that.ticketcodelist[i].childidcard.length;
							}
						}
						if(num > 4) {
							that.success = true;
							that.success_text = '个人一次最多可预约4人（包含儿童）';
							that.success_img = false;
						} else {
							that.establishedShow = true;
						}
					} else {
						if(that.license.length == 0) {
							that.success = true;
							that.success_text = '请上传电子行程单';
							that.success_img = false;
						} else {                                          
							that.establishedShow = true;
						}
					}
				}
			},
			determine() {
				var mo = function(e) {
					e.preventDefault();
				};
				document.body.style.overflow = ''; //出现滚动条
				document.removeEventListener("touchmove", mo, false);
				var that = this;
				if(that.success_text == "预约成功") {
					sessionStorage.removeItem("ticketcodelist")
					sessionStorage.removeItem("license")
					that.$router.push({
						name: 'Success'
					});
				} else {
					that.success = false;
				}
			},
			information_push() {
				var that = this;
				that.index_del = [];
				that.information_delete = false;
				that.edit = "编辑";
				var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
				that.ticketcodelist = codelist;
				if(that.ordertype == '0') {
					if(that.ticketcodelist.length <= 3) {
						that.ticketcodelist.push({
							'realname': '',
							'idcard': '',
							'telnum': '',
							'certificate_type': 'idcard',
							'userstatus': '',
							'show': false,
							'childnum': '',
							'childidcard': []
						})
						sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
					} else {
						that.success = true;
						that.success_text = '已达到添加上限';
						that.success_img = false;
					}
				} else if(that.ordertype == '1') {
					if(that.ticketcodelist.length <= 50) {
						that.ticketcodelist.push({
							'realname': '',
							'idcard': '',
							'telnum': '',
							'certificate_type': 'idcard',
							'userstatus': '',
							'show': false,
							'childnum': '',
							'childidcard': []
						})
						sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
					} else {
						that.success = true;
						that.success_text = '已达到添加上限';
						that.success_img = false;
					}
				}

			}
		},
		mounted() {
			wclient.view.showLoading();
			var that = this;
			that.access_token = window.localStorage.getItem('access_token')
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "https://www.xiangshan1949.cn";
				var baseUrlOne = "http://xs.weapi.org";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "https://www.xiangshan1949.cn";
				var baseUrlOne = "http://xs.weapi.org";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn";
				var baseUrlOne = "https://www.xiangshan1949.cn";
			}
			that.baseUrl = baseUrl;
			that.baseUrlOne = baseUrlOne;
			that.imageurl = sessionStorage.getItem("imageurl");
			that.title = sessionStorage.getItem("title");
			that.site_name = sessionStorage.getItem("site_name");
			that.taid = sessionStorage.getItem("taid");
			that.appointmenttime = sessionStorage.getItem("appointmenttime");
			that.paragraphid = sessionStorage.getItem("paragraphid");
			that.ordertype = sessionStorage.getItem("orderType");
			that.summary = sessionStorage.getItem("summary");
			if(JSON.parse(sessionStorage.getItem('license')) != undefined) {
				that.license = JSON.parse(sessionStorage.getItem('license'));
			} else {
				that.license = [];
			}
			if(sessionStorage.getItem("ticketcodelist") == '' || sessionStorage.getItem("ticketcodelist") == undefined) {
				sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
			} else {
				that.ticketcodelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"))
			}
			wclient.view.hideLoading();
		}
	}
</script>

<style scoped>
	.container {
		float: left;
		width: 92%;
		display: block;
		padding: 0 4%;
		-webkit-overflow-scrolling: touch;
	}
	
	.fill_top {
		width: 90%;
		float: left;
		background: url(../assets/fill_top.png) center center no-repeat;
		background-size: 100% 100%;
		padding: 5%;
		margin-top: 10px;
		margin-bottom: 10px;
	}
	
	.fill_top_head {
		float: left;
		width: 100%;
	}
	
	.fill_top_head_photo {
		float: left;
		width: 75px;
		height: 75px;
		margin-right: 5%;
		border-radius: 10px;
		overflow: hidden;
	}
	
	.fill_top_head_text {
		float: left;
		width: 66%;
		padding: 5px 0;
	}
	
	.fill_top_head_text p {
		width: 100%;
		color: #919CA2;
		font-size: 12px;
	}
	
	.fill_top_head_text p:nth-child(1) {
		margin-bottom: 10px;
		color: black;
		font-weight: 600;
		letter-spacing: 1px;
		font-size: 16px;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-box-pack: center;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}
	
	.fill_top_bottom {
		width: 100%;
		float: left;
		margin-top: 35px;
		display: flex;
		line-height: 20px;
		justify-content: space-between;
	}
	
	.fill_sheets {
		width: 80%;
		font-size: 16px;
		font-weight: 600;
		color: rgba(0, 0, 0, 1);
		opacity: 0.39;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-box-pack: center;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}
	
	.appointmentsheets {
		color: rgba(228, 4, 4, 1);
		font-size: 12px;
	}
	
	.personnel_information {
		float: left;
		width: 90%;
		padding: 10px 5%;
		background: white;
		border-radius: 10px;
		margin-bottom: 10px;
	}
	
	.information_top {
		width: 100%;
		float: left;
		font-size: 16px;
		font-weight: 600;
		border-bottom: 1px solid #eee;
	}
	
	.information_top>p {
		line-height: 40px;
		float: left;
	}
	
	.information_edit {
		width: 18%;
		background: linear-gradient(0deg, rgba(207, 18, 14, 1), rgba(207, 18, 14, 1), rgba(236, 107, 105, 1));
		text-align: center;
		line-height: 30px;
		border-radius: 10px;
		color: white;
		font-size: 14px;
		font-weight: 400;
		float: right;
		margin-right: 10px;
	}
	
	.information {
		width: 100%;
		float: left;
	}
	
	.information_btn {
		float: left;
		width: 36%;
		color: rgba(255, 255, 255, 1);
		line-height: 35px;
		background: linear-gradient(0deg, rgba(207, 18, 14, 1), rgba(207, 18, 14, 1), rgba(236, 107, 105, 1));
		border-radius: 31px;
		text-align: center;
		font-size: 14px;
		margin-left: 32%;
		margin-top: 20px;
		margin-bottom: 20px;
	}
	
	.information li {
		float: left;
		width: 100%;
		padding: 10px 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #eee;
	}
	
	.information_left {
		width: 80%;
		color: rgba(180, 180, 180, 1);
		font-size: 14px;
	}
	
	.information_left>div {
		float: left;
		width: 100%;
	}
	
	.information_left>div>div {
		float: left;
	}
	
	.information_left_ll {
		color: #585858;
		margin-bottom: 10px;
		margin-right: 10px;
	}
	
	.information_left span {
		margin-bottom: 10px;
		color: #B1B1B1;
		font-size: 14px;
	}
	
	.information_left span:nth-child(1) {
		margin-right: 20px;
	}
	
	.information_tips {
		float: left;
	}
	
	.information_tips>div:nth-of-type(1) {
		float: left;
		width: 12px;
		height: 12px;
		border-radius: 50%;
		background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(244, 143, 143, 1));
		line-height: 12px;
		text-align: center;
		color: white;
		margin-top: 5px;
		margin-right: 5px;
	}
	
	.information_tips>div:nth-of-type(2) {
		float: left;
		font-size: 12px;
		color: rgba(228, 4, 4, 1);
		line-height: 20px;
		margin-top: 1px;
	}
	
	.information_right img {
		width: 7px;
		height: 10px;
	}
	
	.information_delete img {
		width: 20px;
	}
	
	.appointment_explain {
		float: left;
		width: 90%;
		padding: 10px 5%;
		background: white;
		border-radius: 10px;
		margin-bottom: 10px;
	}
	
	.appointment_explain>p {
		width: 100%;
		float: left;
		font-size: 16px;
		font-weight: 600;
	}
	
	.explain_height {
		width: 100%;
		height: 80px;
		float: left;
		margin-top: 15px;
		margin-bottom: 20px;
		font-size: 14px;
		color: rgba(177, 177, 177, 1);
		line-height: 25px;
		overflow: hidden;
	}
	
	.explain_height_change {
		width: 100%;
		float: left;
		margin-top: 15px;
		margin-bottom: 20px;
		font-size: 14px;
		color: rgba(177, 177, 177, 1);
		line-height: 25px;
		overflow: hidden;
	}
	
	.appointment_explain>div:nth-of-type(2) {
		width: 4%;
		margin-left: 48%;
		margin-top: 20px;
		margin-bottom: 20px;
	}
	
	.visit_explain {
		float: left;
		width: 90%;
		padding: 10px 5%;
		background: white;
		border-radius: 10px;
		margin-bottom: 80px;
	}
	
	.visit_explain>p {
		width: 100%;
		float: left;
		font-size: 16px;
		font-weight: 600;
	}
	
	.visit_height {
		width: 100%;
		height: 80px;
		float: left;
		margin-top: 15px;
		margin-bottom: 20px;
		font-size: 14px;
		color: rgba(177, 177, 177, 1);
		line-height: 25px;
		overflow: hidden;
	}
	
	.visit_height_change {
		width: 100%;
		float: left;
		margin-top: 15px;
		margin-bottom: 20px;
		font-size: 14px;
		color: rgba(177, 177, 177, 1);
		line-height: 25px;
		overflow: hidden;
	}
	
	.visit_explain>div:nth-of-type(2) {
		width: 4%;
		margin-left: 48%;
		margin-top: 20px;
		margin-bottom: 20px;
	}
	
	.fill_btn_bottom {
		width: 100%;
		position: fixed;
		bottom: 0;
		left: 0;
		background: white;
	}
	
	.child {
		width: 100%;
		display: block;
	}
	
	.fill_btn {
		margin: 10px auto;
		width: 70%;
		background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));
		border-radius: 40px;
		color: rgba(254, 254, 254, 1);
		line-height: 45px;
		text-align: center;
		font-size: 14px;
	}
	
	.appointment_success {
		width: 110%;
		height: 100%;
		background: rgba(0, 0, 0, 0.54);
		position: fixed;
		top: 0;
		left: 0;
	}
	
	.success_center {
		margin-top: 28%;
		background: white;
		width: 60%;
		margin-left: 15%;
		padding-top: 10px;
		border-radius: 10px;
	}
	
	.success_center img {
		width: 25%;
		margin-left: 37%;
		margin-top: 30px;
	}
	
	.success_center p:nth-of-type(1) {
		width: 90%;
		color: black;
		font-size: 16px;
		font-weight: 600;
		text-align: center;
		margin-top: 20px;
		padding: 0 5%;
	}
	
	.success_center p:nth-of-type(2) {
		width: 100%;
		color: black;
		font-size: 16px;
		text-align: center;
		margin-top: 5px;
		letter-spacing: 1px;
	}
	
	.success_center div {
		width: 100%;
		line-height: 45px;
		text-align: center;
		font-weight: 600;
		color: rgba(228, 4, 4, 1);
		border-top: 1px solid #eee;
		margin-top: 25px;
	}
	
	.inp_file {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		margin-top: 10px;
		float: left;
	}
	
	.file {
		float: left;
		position: relative;
		width: 30%;
		height: 100px;
		margin-bottom: 10px;
		border-radius: 10px;
		-webkit-box-shadow: 0px 3px 10px 0px #b1b1b1;
		box-shadow: 0px 3px 10px 0px #b1b1b1;
		margin-right: 3%;
	}
	
	.file:last-child {
		margin-right: 0;
	}
	
	.file_img {
		float: left;
		width: 100%;
		height: 100%;
	}
	
	.file input {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0px;
		top: 0px;
		opacity: 0;
		-ms-filter: 'alpha(opacity=0)';
	}
	
	.file_no {
		position: absolute;
		top: -8px;
		right: -8px;
		width: 25px;
		height: 25px;
		border-radius: 50%;
		box-shadow: 0px 1px 7px 2px rgba(154, 154, 154, 0.2);
		color: #9A9A9A;
		background: rgb(252, 245, 247);
	}
	
	p {
		margin-bottom: 0;
	}
	
	.established {
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
	}
	
	.established_content {
		width: 66%;
		background: white;
		border-radius: 10px;
	}
	
	.established_top {
		width: 100%;
		text-align: center;
		line-height: 50px;
		font-size: 18px;
	}
	
	.established_top_one {
		width: 100%;
		text-align: center;
		line-height: 100px;
		font-size: 15px;
	}
	
	.established_top_top {
		width: 90%;
		text-align: center;
		line-height: 25px;
		font-size: 15px;
		margin: 20px auto;
		color: black;
	}
	
	.established_bottom {
		width: 100%;
		display: flex;
		justify-content: space-between;
		border-top: 1px solid #b1b1b1;
	}
	
	.established_bottom div {
		width: 50%;
		text-align: center;
		line-height: 40px;
		font-size: 16px;
	}
	
	.established_bottom div:nth-child(1) {
		border-right: 1px solid #b1b1b1;
	}
</style>


// WEBPACK FOOTER //
// src/components/fill_information.vue